import { render, staticRenderFns } from "./AdditionalDetails.vue?vue&type=template&id=52cff767&scoped=true"
import script from "./AdditionalDetails.vue?vue&type=script&lang=js"
export * from "./AdditionalDetails.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDetails.vue?vue&type=style&index=0&id=52cff767&prod&scoped=true&lang=css"
import style1 from "./AdditionalDetails.vue?vue&type=style&index=1&id=52cff767&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cff767",
  null
  
)

export default component.exports